var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoicon10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.1847 6.85547H30.667C30.667 10.15 31.9757 13.3095 34.3053 15.6391C36.6349 17.9687 39.7944 19.2774 43.0889 19.2774H48.158V24.1717C48.1625 31.0259 53.7177 36.5813 60.5719 36.5858V9.24263C60.5719 7.92461 59.5034 6.85547 58.1847 6.85547Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5692 20.5674H17.0518C17.056 27.4216 22.6112 32.977 29.4656 32.9815H34.5347V37.8914C34.5434 44.7456 40.1024 50.2972 46.9566 50.2972V22.955C46.9566 21.6365 45.8877 20.5674 44.5692 20.5674Z",
    fill: "url(#paint0_linear_349_6693)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9454 34.2705H3.42773C3.42773 41.131 8.98942 46.6924 15.8497 46.6924H20.9346V51.5865C20.9391 58.4344 26.4847 63.9874 33.3328 64.0004V36.6579C33.3328 35.3394 32.2639 34.2705 30.9454 34.2705Z",
    fill: "url(#paint1_linear_349_6693)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_349_6693",
    x1: 7502.14,
    y1: 34.2549,
    x2: 4533.54,
    y2: 3503.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_349_6693",
    x1: 7689.69,
    y1: 72.9521,
    x2: 4255.79,
    y2: 3856.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoicon10);
export default __webpack_public_path__ + "static/media/logoicon10.90ca0633c8fcc42f3579d59aa93817e2.svg";
export { ForwardRef as ReactComponent };